export default __webpack_public_path__ + "9a7212f.png";